import { endpoints } from 'api/endpoints'
import { GetArrayResponse } from 'interfaces/api.interfaces'
import { axios } from 'modules/axios'

const getHosts = async (): GetArrayResponse<string> => {
  const { data: response } = await axios.request<string[]>({
    method: 'GET',
    url: endpoints.promoOptimizerSettings.getHosts(),
  })
  return response
}

const getEndpoints = async (): GetArrayResponse<string> => {
  const { data: response } = await axios.request<string[]>({
    method: 'GET',
    url: endpoints.promoOptimizerSettings.getEndpoints(),
  })
  return response
}

export const promoOptimizerSettingsApi = {
  getHosts,
  getEndpoints,
}
